/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, change: NonNullable<unknown> }} Workout_After_Carry_IncludeInputs */

const en_us2_workout_after_carry_include = /** @type {(inputs: Workout_After_Carry_IncludeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bring into my plan: ${i?.name}, ${i?.change}`)
};

const pt_br2_workout_after_carry_include = /** @type {(inputs: Workout_After_Carry_IncludeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Levar para o plano: ${i?.name}, ${i?.change}`)
};

const es_419_workout_after_carry_include = /** @type {(inputs: Workout_After_Carry_IncludeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Llevar a mi plan: ${i?.name}, ${i?.change}`)
};

const pt_pt2_workout_after_carry_include = /** @type {(inputs: Workout_After_Carry_IncludeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Levar para o plano: ${i?.name}, ${i?.change}`)
};

const fr_fr2_workout_after_carry_include = /** @type {(inputs: Workout_After_Carry_IncludeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reporter dans mon programme : ${i?.name}, ${i?.change}`)
};

const de_de2_workout_after_carry_include = /** @type {(inputs: Workout_After_Carry_IncludeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`In meinen Plan übernehmen: ${i?.name}, ${i?.change}`)
};

const it_it2_workout_after_carry_include = /** @type {(inputs: Workout_After_Carry_IncludeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Porta nella scheda: ${i?.name}, ${i?.change}`)
};

/**
* | output |
* | --- |
* | "Bring into my plan: {name}, {change}" |
*
* @param {Workout_After_Carry_IncludeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_carry_include = /** @type {((inputs: Workout_After_Carry_IncludeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Carry_IncludeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_carry_include(inputs)
	if (locale === "es-419") return es_419_workout_after_carry_include(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_carry_include(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_carry_include(inputs)
	if (locale === "de-DE") return de_de2_workout_after_carry_include(inputs)
	if (locale === "it-IT") return it_it2_workout_after_carry_include(inputs)
	return en_us2_workout_after_carry_include(inputs)
});
export { workout_after_carry_include as "workout-after.carry_include" }